import { useContext, useLayoutEffect } from 'react';
import useGetter from '@dyl/hooks/useGetter';
import TaskContext from './TaskContext';

export default function useLocalTaskError(message, cb) {
    const { registerLocalError } = useContext(TaskContext);

    const getCb = useGetter(cb);

    useLayoutEffect(() => {
        if (!message) return;

        const unregister = registerLocalError(message, (...args) => getCb()?.(...args));

        return () => unregister();
    }, [registerLocalError, message]);
}